import {
  AnimationComponent,
  Box,
  Edit1Icon,
  GKButton,
  Grid2,
  Show,
  Tab,
  Tabs,
} from "components";
import { useFetchQuery } from "hooks/useQueries";
import DashboardLayout from "layouts/DashboardLayout";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { SET_SELECTED_BASKET } from "store/slices/equityBasketSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import { UserRoleTypes } from "utils/common";
import MethodologiesTab from "./EquityBasketMethodologiesTab";
import EquityBasketView from "./EquityBasketView";
import ViewFeePlans from "./ViewFeePlans";
import ViewRationaleTab from "./ViewRationaleTab";
import ViewRebalanceTab from "./ViewRebalanceTab";
import ViewReportsTab from "./ViewReportsTab";
import ViewSettingsTab from "./ViewSettingsTab";
import ViewTelegramTab from "./ViewTelegramTab";

const EquityBasketViewDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const userData = useAppSelector((state) => state?.user?.userData);

  const [tabValue, setTabValue] = useState(0);

  const { data, isFetching } = useFetchQuery({
    key: ["GET_MODEL_PORTFOLIO_DETAILS_DATA"],
    route: `/model_portfolio/${id}/details/`,
    enabled: Boolean(id),
    success: (response: any) => {
      dispatch(SET_SELECTED_BASKET(response?.data));
    },
  });

  const tabs = [
    {
      label: "Meta",
      component: <EquityBasketView />,
    },
    { label: "Rationale", component: <ViewRationaleTab /> },
    {
      label: "Methodologies",
      component: <MethodologiesTab />,
    },
    {
      label:
        data?.data?.basketType === "Asset" ? "Recommendation" : "Rebalance",
      component: <ViewRebalanceTab />,
    },
    { label: "Fee Plan", component: <ViewFeePlans /> },
    { label: "Telegram", component: <ViewTelegramTab /> },
    { label: "Reports", component: <ViewReportsTab /> },
    { label: "Settings", component: <ViewSettingsTab /> },
  ];

  return (
    <DashboardLayout title="Basket View" loading={isFetching} disablePadding>
      <Grid2 container>
        <Grid2 size={12}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Grid2 container mx={3}>
              <Grid2 size={9}>
                <Tabs
                  sx={{
                    "& .MuiTabs-flexContainer": {
                      backgroundColor: "var(--white)",
                    },
                  }}
                  onChange={(e, val) => setTabValue(val)}
                  value={tabValue}
                >
                  {tabs.map((tab, index) => (
                    <Tab key={index} label={tab.label} disableRipple />
                  ))}
                </Tabs>
              </Grid2>
              <Grid2
                size={3}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"flex-end"}
              >
                {userData?.userRole === UserRoleTypes.advisor && (
                  <GKButton
                    size="small"
                    startIcon={<Edit1Icon />}
                    onClick={() => {
                      navigate(`/app/equity-basket/${id}/edit`);
                    }}
                  >
                    Edit Basket
                  </GKButton>
                )}
              </Grid2>
            </Grid2>
          </Box>
        </Grid2>
        <Grid2
          size={12}
          p={3}
          maxHeight={"calc(100vh - 116px)"}
          overflow={"auto"}
        >
          {tabs.map((tab, index) => (
            <Show.When key={index} isTrue={tabValue === index}>
              <AnimationComponent>{tab.component}</AnimationComponent>
            </Show.When>
          ))}
        </Grid2>
      </Grid2>
    </DashboardLayout>
  );
};

export default EquityBasketViewDetails;
